import { useContext } from 'preact/hooks'

import BaseContext from 'contexts/base-context'
import { isSmScreen, isMdScreen } from 'scripts/utils'

const useParentWindowSize = () => {
  const { parentWindowSize } = useContext(BaseContext)

  return { windowSizeMd: isMdScreen(parentWindowSize), windowSizeSm: isSmScreen(parentWindowSize) }
}

export default useParentWindowSize
